import React, { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

const AudioPlayer = ({ text, autoPlay = false }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [utterance, setUtterance] = useState(null);

  useEffect(() => {
    if ("speechSynthesis" in window) {
      const synth = window.speechSynthesis;
      const u = new SpeechSynthesisUtterance(text);
      u.voice = synth
        .getVoices()
        .find((voice) => voice.name === "Google US English Female");
      u.rate = 0.9;
      u.pitch = 0.9;

      u.onend = () => setIsPlaying(false);
      u.onerror = () => setIsPlaying(false);

      setUtterance(u);

      // Auto-play if enabled
      if (autoPlay) {
        synth.speak(u);
        setIsPlaying(true);
      }
    }
  }, [text, autoPlay]);

  const togglePlayback = () => {
    const synth = window.speechSynthesis;

    if (isPlaying) {
      synth.cancel();
      setIsPlaying(false);
    } else {
      synth.speak(utterance);
      setIsPlaying(true);
    }
  };

  useEffect(() => {
    return () => {
      if ("speechSynthesis" in window) {
        window.speechSynthesis.cancel();
      }
    };
  }, []);

  if (!("speechSynthesis" in window)) return null;

  return (
    <IconButton
      size="small"
      onClick={togglePlayback}
      sx={{
        ml: 1,
        color: isPlaying ? "primary.main" : "text.secondary",
      }}
    >
      {isPlaying ? <VolumeOffIcon /> : <VolumeUpIcon />}
    </IconButton>
  );
};

export default AudioPlayer;
